/* eslint-disable max-len */
import gql from "graphql-tag";

export const registerCompanyEnrolledWithBatchEventQuery = gql`
  mutation RegisterCompanyEnrolledWithBatchEventQuery(
    $odeId: ID!,
    $batchId: ID!,
    $data: Json
  ) {
    updateODE(
      where: { id: $odeId }
      data: {
        events: {
          create: {
            batches: { connect: { id: $batchId } },
            name: COMPANY_ENROLLED_WITH_BATCH,
            description: "The Company has been enrolled with the Batch. Check the data field to get more info.",
            data: $data,
          }
        }
      }
    ) {
      id
      events {
        id
        name
        data
        description
      }
    }
  }
`;
